<template>

<v-dialog v-model="dialog" width="600px">
  <v-card>
    <p class=".title ma-2">Add a discount rule to {{akcd.akcd_oms }} </p>
    <v-form ref="addAkpr" v-model="addAkprValid">
     
     
     <v-row no-gutters>  
      <v-col cols="6" class="px-2">
        <v-menu
          v-model="akcd.akpr_verb_van_datMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          readonly 
          offset-y
          min-width="290px"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="akcd.akpr_verb_van_dat"
            label="Stay from"
            v-on="on"
            clearable
            hint="Only enter a date when applicable"
          ></v-text-field>
        </template>
        <v-date-picker v-model="akcd.akpr_verb_van_dat" :first-day-of-week="1" @input="akcd.akpr_verb_van_datMenu = false"></v-date-picker>
        </v-menu>  
      </v-col> 
      <v-col cols="6" class="px-2">
        <v-menu
          v-model="akcd.akpr_verb_tm_datMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          readonly 
          offset-y
          min-width="290px"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="akcd.akpr_verb_tm_dat"
            label="Stay until"
            v-on="on"
            clearable
            hint="Only enter a date when applicable"
          ></v-text-field>
        </template>
        <v-date-picker v-model="akcd.akpr_verb_tm_dat" :first-day-of-week="1" @input="akcd.akpr_verb_tm_datMenu = false"></v-date-picker>
        </v-menu>  
      </v-col> 
     </v-row>  

     <v-row no-gutters>  
      <v-col cols="6" class="px-2">
        <v-menu
          v-model="akcd.akpr_boek_van_datMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          readonly 
          offset-y
          min-width="290px"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="akcd.akpr_boek_van_dat"
            label="Booking date from"
            v-on="on"
            clearable
            hint="Only enter a date when applicable"
          ></v-text-field>
        </template>
        <v-date-picker v-model="akcd.akpr_boek_van_dat" :first-day-of-week="1" @input="akcd.akpr_boek_van_datMenu = false"></v-date-picker>
        </v-menu>  
      </v-col> 
      <v-col cols="6" class="px-2">
        <v-menu
          v-model="akcd.akpr_boek_tm_datMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          readonly 
          offset-y
          min-width="290px"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="akcd.akpr_boek_tm_dat"
            label="Booking date until"
            v-on="on"
            clearable
            hint="Only enter a date when applicable"
          ></v-text-field>
        </template>
        <v-date-picker v-model="akcd.akpr_boek_tm_dat" :first-day-of-week="1" @input="akcd.akpr_boek_tm_datMenu = false"></v-date-picker>
        </v-menu>  
      </v-col> 
     </v-row>  

     <v-row no-gutters>
       <v-col class="px-2">
         <v-text-field v-model="akcd.akpr_advb_van" label="Number of days before stay from" type="number"  hint="Only enter a number when applicable"></v-text-field>
       </v-col> 
       <v-col class="px-2">
         <v-text-field v-model="akcd.akpr_advb_tm" label="Number of days before stay until" type="number"  hint="Only enter a number when applicable"></v-text-field>
       </v-col>   
     </v-row>   

     <v-row no-gutters>
      <v-col class="px-2">  
         <v-select v-model="akcd.akpr_aant_nacht_van" :items="nacht_nrKeuzes" item-value="nacht_nr" item-text="nacht_oms" label="Stay - Number of nights from" dense></v-select>
      </v-col>
      <v-col class="px-2">  
         <v-select v-model="akcd.akpr_aant_nacht_tm" :items="nacht_nrKeuzes" item-value="nacht_nr" item-text="nacht_oms" label="Stay - Number of nights until" dense></v-select>
      </v-col>      
     </v-row>    

     <v-row no-gutters>
      <v-col class="px-2">  
         <v-select v-model="akcd.akpr_dag_van" :items="dag_nrKeuzes" item-value="dag_nr" item-text="dag_oms" label="Arrival day" dense></v-select>
      </v-col>
      <v-col class="px-2">  
         <v-select v-model="akcd.akpr_dag_tm" :items="dag_nrKeuzes" item-value="dag_nr" item-text="dag_oms" label="Departure day" dense></v-select>
      </v-col>      
     </v-row>     

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addAkpr" :disabled="!addAkprValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addAkprValid: false,
      akcd_encrid: null,
      nacht_nrKeuzes: [],
      dag_nrKeuzes: [],
      akcd: {}
    }
  },
  methods: {
    open(akcd_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.akcd_encrid = akcd_encrid;
      this.$axios
        .post("ares/json/ares/syst/ref/akcd/getAkcdToAddAkpr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getAkcdToAddAkpr"
          },
          getAkcdToAddAkpr: {
            akcd_encrid: akcd_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.akcd = res.data.getAkcdToAddAkpr;
            res.data.getAkcdToAddAkpr.nacht_nrKeuzes.forEach(function(nacht) {
             deze.nacht_nrKeuzes.push(nacht); 
            });
            res.data.getAkcdToAddAkpr.dag_nrKeuzes.forEach(function(dag) {
             deze.dag_nrKeuzes.push(dag); 
            })
            deze.akcd_encrid = akcd_encrid;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addAkpr() { 
      this.$axios
        .post("ares/json/ares/syst/ref/akcd/addAkpr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addAkpr"
          },
          addAkpr: {
            akcd_encrid: this.akcd.akcd_encrid,
            akpr_verb_van_dat: this.akcd.akpr_verb_van_dat,
            akpr_verb_tm_dat: this.akcd.akpr_verb_tm_dat,
            akpr_boek_van_dat: this.akcd.akpr_boek_van_dat,
            akpr_boek_tm_dat: this.akcd.akpr_boek_tm_dat,
            akpr_advb_van: parseInt(this.akcd.akpr_advb_van),
            akpr_advb_tm: parseInt(this.akcd.akpr_advb_tm),
            akpr_aant_nacht_van: parseInt(this.akcd.akpr_nacht_aant_van),
            akpr_aant_nacht_tm: parseInt(this.akcd.akpr_nacht_aant_tm),
            akpr_dag_van: parseInt(this.akcd.akpr_dag_van),
            akpr_dag_tm: parseInt(this.akcd.akpr_dag_tm)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
             if (res.data.addAkpr.color == "success") {
                 this.$router.reload('/syst/ref/akcd/searchAkcd/');   
             }
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addAkpr.text,
              color: res.data.addAkpr.color
            }); 
            this.dialog = false;
          }
        })
    }
  }
}
</script>

